const CLOCK_EMOJIES = [
  // twelve
  {
    oClock: "🕛",
    thirty: "🕧",
  },
  // one
  {
    oClock: "🕐",
    thirty: "🕜",
  },
  // two
  {
    oClock: "🕑",
    thirty: "🕝",
  },
  // three
  {
    oClock: "🕒",
    thirty: "🕞",
  },
  // four
  {
    oClock: "🕓",
    thirty: "🕟",
  },
  // five
  {
    oClock: "🕔",
    thirty: "🕠",
  },
  // six
  {
    oClock: "🕕",
    thirty: "🕡",
  },
  // seven
  {
    oClock: "🕖",
    thirty: "🕢",
  },
  // eight
  {
    oClock: "🕗",
    thirty: "🕣",
  },
  // nine
  {
    oClock: "🕘",
    thirty: "🕤",
  },
  // ten
  {
    oClock: "🕙",
    thirty: "🕥",
  },
  // eleven
  {
    oClock: "🕚",
    thirty: "🕦",
  },
] as const;

export function getSolveTimeEmoji(timeInSeconds: number) {
  if (timeInSeconds <= 5) {
    return "⚡";
  }
  if (timeInSeconds < 15) {
    return "🚀";
  }

  let minuteHand = 0;
  while (minuteHand < 12) {
    const secondHand = timeInSeconds - 60 * minuteHand;
    if (secondHand < 15) {
      return CLOCK_EMOJIES[minuteHand].oClock;
    }
    if (secondHand < 45) {
      return CLOCK_EMOJIES[minuteHand].thirty;
    }
    minuteHand = minuteHand + 1;
  }

  return "🐢";
}
